var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.classes),function(schoolClass){return _c('Class',{key:schoolClass.$id,attrs:{"schoolid":_vm.school,"classid":schoolClass.$id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }